import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const groupProjectAPI = createApi({
    reducerPath: 'groupProjectAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        addGroupProject: builder.mutation({
            query: (data) => ({
                url: `/GroupProject/AddGroupProject`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getGroupProjectsByGroupId: builder.query({
            query: (groupId) => ({
                url: `/GroupProject/GetGroupProjectsByGroupId?GroupId=${groupId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUnassignGroupProjectsByGroupId: builder.query({
            query: (groupId) => ({
                url: `/GroupProject/GetUnassignGroupProjectsByGroupId?GroupId=${groupId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteGroupProject: builder.mutation({
            query: (groupPrjectId) => ({
                url: `/GroupProject/DeleteGroupProject?GroupProjectId=${groupPrjectId}`,
                method: 'DELETE',
                body: transformRequest(groupPrjectId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
});

export const {
    useAddGroupProjectMutation,
    useLazyGetGroupProjectsByGroupIdQuery,
    useLazyGetUnassignGroupProjectsByGroupIdQuery,
    useDeleteGroupProjectMutation
} = groupProjectAPI;

export default groupProjectAPI;